// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { itemListStyles } from "@guestsupply/Overrides/Widgets/Basic/ItemList";
import { css } from "styled-components";

itemListStyles.itemListWrapper = {
    css: css`
        text-align: right;
        text-transform: uppercase;
        padding: 10px 0;
    `,
};

itemListStyles.titleWrapper = {
    css: css`
        font-weight: bold;
        margin-bottom: 15px;
    `,
};

itemListStyles.linkWrapper = {
    css: css`
        padding: 0;
        margin-bottom: 12px;
        line-height: 15px;
    `,
};

itemListStyles.link = {
    color: "text",
    typographyProps: {
        size: 12,
        lineHeight: "15px",
        transform: "initial",
    },
};
